/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrepareRecoveryActivitiesRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {PrepareRecoveryActivitiesResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const prepareRecoveryActivities = (request: PrepareRecoveryActivitiesRequest, options?: CashRequestOptions) => post<PrepareRecoveryActivitiesRequest, PrepareRecoveryActivitiesResponse>("/2.0/cash/prepare-recovery-activities", request, {...options, rejectOnError: true })